<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createProyecto"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mFeedAssetsContentModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="proyecto.titulo"
          :inputError="$v.proyecto.titulo.$error"
          :label="$t('mFeedAssetsContentModalCreate.inputs.titulo.label')"
          :message="$t('mFeedAssetsContentModalCreate.inputs.titulo.message')"
          :messageError="messageErrorTitulo"
          name="titulo"
          type="text"
          @blur="$v.proyecto.titulo.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mFeedAssetsContentModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeFeedAssetsContentModalCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedAssetsContentModalCreate.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      proyecto: {
        academia: '',
        proyecto_categoria: 1,
        proyecto_tipo: 0,
        titulo: ''
      }
    }
  },

  validations: {
    proyecto: {
      titulo: {
        maxLength: maxLength(120),
        minLength: minLength(5),
        required
      }
    }
  },

  computed: {
    messageErrorTitulo () {
      return this.$validation.getValidationMessage('mFeedAssetsContentModalCreate', this.$v.proyecto.titulo, 'titulo')
    }
  },

  created () {
    this.proyecto.academia = this.$store.getters.getAcademyData.id
  },

  methods: {
    createProyecto () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('proyecto', 'createProyecto', this.proyecto)
          .then(response => {
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedAssetsContentModalCreate', 'createProyecto', 'success')
            this.$router.push(`/${this.$t('rPaths.asset')}/${response.data.id}/${this.$t('mEditionMenu.asset.card.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedAssetsContentModalCreate', 'createProyecto', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
